export const CREATE_EDIT_POLL = 'CreateInvitationWidget/*/CreateEditPoll';
export const CREATE_EDIT_WTB = 'CreateInvitationWidget/*/CreateEditWTB';
export const SET_WIDGETS = 'CreateInvitationWidget/*/SetWidgets';
